import React from 'react';
import { CaptureOverlay } from '../shared';
import type { ScreenMode } from './useScreenRecorder';

interface ScreenReadyProps {
  taskName: string;
  screenRef: React.RefObject<HTMLVideoElement | null>;
  camRef: React.RefObject<HTMLVideoElement | null>;
  mode: ScreenMode;
  isLandscape: boolean;
  onRecord: () => void;
  onClose: () => void;
}

export const ScreenReady: React.FC<ScreenReadyProps> = ({
  taskName,
  screenRef,
  camRef,
  mode,
  isLandscape,
  onRecord,
  onClose,
}) => {
  return (
    <CaptureOverlay taskName={taskName} onClose={onClose}>
      <div className={isLandscape ? 'sc-landscape' : undefined}>
        <div className="sc-screen-body">
          <div className="sc-screen-gradient" />
          <video ref={screenRef} autoPlay playsInline muted />

          {/* Facecam PiP */}
          {mode === 'screen-cam' && (
            <div className="sc-facecam-bubble">
              <video ref={camRef} autoPlay playsInline muted />
            </div>
          )}
        </div>

        <div className="sc-ctrl-bar">
          <div className="sc-status-dim">Screen sharing active</div>
          <div className="sc-big-rec-btn-dim" onClick={onRecord}>
            <div className="sc-rec-dot-lg" />
          </div>
          <div className="sc-ctrl-spacer" />
        </div>
      </div>
    </CaptureOverlay>
  );
};
